module.exports = __webpack_public_path__ + "static/media/article3-image.b3dd1d67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/article3-image.png
// module id = 360
// module chunks = 3